interface Props {
  color?: 'black' | 'white';
  width?: string;
}

export const Logo: (props: Props) => JSX.Element = ({
  color = 'black',
  width,
}: Props) => (
  <svg
    role="img"
    width={width}
    fill={color}
    aria-label="Quickbit"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 1160.08 283.46"
  >
    <defs>
      <clipPath id="clip-path" transform="translate(-160.69 -99.3)">
        <rect className="cls-1" width="1479.93" height="482.17" />
      </clipPath>
      <clipPath id="clip-path-2" transform="translate(-160.69 -99.3)">
        <rect className="cls-1" width="1479.93" height="482.17" />
      </clipPath>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g className="cls-2">
          <g className="cls-3">
            <path
              className="cls-4"
              d="M464.57,253.23c0,21.72-16.58,38.06-35.3,38.06-16.58,0-27.32-9.21-27.32-27.62v-103H356.83V266.43c0,37.75,23,58.16,59.09,58.16,29,0,42.05-18.16,47.42-26.6h3.07v23.38h43.28V160.69H464.57Z"
              transform="translate(-160.69 -99.3)"
            />
            <rect
              className="cls-4"
              x="377.86"
              y="61.39"
              width="45.27"
              height="160.69"
            />
            <rect
              className="cls-4"
              x="377.71"
              y="1.07"
              width="45.43"
              height="38.06"
            />
            <polygon
              className="cls-4"
              points="782.63 65.99 782.63 61.39 733.36 61.39 670.9 121.4 667.83 121.4 667.83 1.07 623.17 1.07 623.17 222.07 667.83 222.07 667.83 174.65 685.17 158.23 735.05 222.07 783.4 222.07 783.4 217.47 713.72 131.22 782.63 65.99"
            />
            <rect
              className="cls-4"
              x="990.57"
              y="1.07"
              width="45.43"
              height="38.06"
            />
            <rect
              className="cls-4"
              x="990.72"
              y="61.39"
              width="45.27"
              height="160.69"
            />
            <path
              className="cls-4"
              d="M1320.77,190.77V160.69h-33.31V118.17H1242.8v42.52h-29.16v30.08h29.16v88.09c0,27.63,17,42.51,45.12,42.51H1320V289.76h-20.11c-8.13,0-12.43-4.45-12.43-12.28V190.77Z"
              transform="translate(-160.69 -99.3)"
            />
            <path
              className="cls-4"
              d="M286.83,184.07h-3.07C276.6,171,258,157.62,235,157.62c-40,0-74.26,26.55-74.26,83.49S194.9,324.59,235,324.59c22.69,0,39.86-12.94,46.81-24h3.07v82.16h45.28V160.69H286.83ZM247.08,291.14c-23.94,0-42.11-17-42.11-50s18.17-50.19,42.11-50.19c21.94,0,39.75,17.19,39.75,50.19s-18.15,50-39.75,50"
              transform="translate(-160.69 -99.3)"
            />
            <path
              className="cls-4"
              d="M1055.2,157.46c-22.69,0-39.86,12.95-46.81,24h-3.07V99.3H960.05V321.37h43.28V298h3.07c7.16,13.09,25.76,26.45,48.8,26.45,40.06,0,74.27-26.55,74.27-83.49s-34.21-83.49-74.27-83.49m-12.12,133.68c-21.95,0-39.75-17.19-39.75-50.19s18.14-50,39.75-50c23.94,0,42.1,17,42.1,50s-18.16,50.19-42.1,50.19"
              transform="translate(-160.69 -99.3)"
            />
            <path
              className="cls-4"
              d="M688.78,292.21c-24.09,0-38.67-18.57-38.67-51.11S664.69,190,688.78,190c21.64,0,30.23,13.81,31.61,28.39H762.6v-4.6C760,184,734.67,157,688.16,157c-48.95,0-83.64,29-83.64,84.1s34.69,84,83.64,84c47.12,0,72-26.71,75.51-58.94v-4.6h-42.2c-2.15,15.5-10.13,30.69-32.69,30.69"
              transform="translate(-160.69 -99.3)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
